import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PageHero from "../components/PageHero";
import { Arrow } from "../components/Icons";
import useReveal from "../utils/useReveal";
import photoWorship from "../assets/images/church.jpg";
import photoCharagu from "../assets/images/charagu.jpg";
import photoMuna from "../assets/images/muna.jpg";

const FACTS = [
    { value: "1980", label: "the year the ministry was started" },
    { value: "6", label: "chapters: Nairobi, Nyeri, Embu-Kerugoya, Mombasa, Nakuru and the Diaspora" },
    { value: "100+", label: "active members" },
    { value: "1,000+", label: "people associated with the work of the ministry" },
];

function AboutUs() {
    useReveal();

    return (
        <div className="cf-public">
            <Header />
            <main>
                <PageHero photo={photoWorship} eyebrow="About us" title="Commissioners for Christ Ministry">
                    A Christian inter-denominational organization made up of Christian professionals from
                    different disciplines who have zeal and a passion for evangelistic work.
                </PageHero>

                <section className="cf-sec">
                    <div className="cf-wrap cf-about">
                        <div>
                            <span className="cf-eyebrow">Our story</span>
                            <h2 className="cf-sec-title">Started in 1980 by young people with a burden for the lost</h2>

                            <div className="cf-about-text">
                                <p>
                                    Commissioners for Christ Ministry (CFCM) is a Christian inter-denominational organization made up of Christian professionals from different disciplines who have zeal and a passion for evangelistic work. The ministry was started in 1980 by a team of passionate young brothers and sisters who felt compelled to reach out to young people and evangelize the good news of our Lord Jesus Christ. In 1982, the ministry experienced exponential growth after more young preachers joined to form a much bigger team.
                                </p>
                                <p>
                                    Though the main area of operation was Nairobi, the growth necessitated the formation of a branch also referred to us Chapter in Nyeri. The team met monthly on a rotational basis where the members would visit each other over a weekend to plan and pray over ministry activities and initiatives. Later, the team would start meeting more frequently at a central point for example the Nairobi Chapter would meet at Ufungamano house every Thursday for a time of prayer and sharing the word.
                                </p>
                                <p>
                                    In addition to the two initial chapters of Nyeri and Nairobi, the ministry expanded to have four additional chapters including Embu- Kerugoya, Mombasa, Nakuru and Diaspora chapter which consists of members outside the boundaries of Kenya but committed to the great commission of reaching out to the lost souls. Currently the ministry has a membership of more than 100 active members and more than 1000 associated with the work of the ministry.
                                </p>
                            </div>
                        </div>

                        <img
                            className="cf-about-photo"
                            src={photoCharagu}
                            alt="A CFCM member speaking at an outdoor gathering"
                        />
                    </div>
                </section>

                <section className="cf-band">
                    <div className="cf-wrap">
                        <div className="cf-facts">
                            {FACTS.map((fact, index) => (
                                <div className="cf-step cf-reveal" key={fact.label} style={{ "--cf-delay": `${index * 0.08}s` }}>
                                    <strong>{fact.value}</strong>
                                    <p>{fact.label}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="cf-sec">
                    <div className="cf-wrap cf-about is-flipped">
                        <img
                            className="cf-about-photo"
                            src={photoMuna}
                            alt="A CFCM member reading from the Bible at an outdoor gathering"
                            loading="lazy"
                        />

                        <div>
                            <span className="cf-eyebrow">The work today</span>
                            <h2 className="cf-sec-title">The harvest is plenty and the work is increasing</h2>

                            <div className="cf-about-text">
                                <p>
                                    CFCM continues to enjoy God’s favor in the mission field with hundreds of students and other members of the society receiving Christ every year as we preach the Gospel. We must admit the harvest is plenty and the work is increasing and thus the need to partner and reach out to more people with the gospel of our Lord Jesus Christ.
                                </p>
                                <p>
                                    The approach of ministry at CFCM has been reaching out to young people in schools. For more than 30 years since its inception, the team has traversed many high schools with one common message of repentance. Thousands of young people have come to accept Jesus as Lord and Savior over their lives. The other aspects of ministry include annual missions, annual conferences dubbed the Gold conference, and annual reflections where the team get together and have time to have personal connection and intimate time with the Lord Jesus
                                </p>
                            </div>

                            <div className="cf-cta-row">
                                <Link className="cf-btn cf-btn-primary" to="/signup">Become a member <Arrow /></Link>
                                <Link className="cf-btn cf-btn-ghost" to="/support-the-ministry">Support the ministry</Link>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}

export default AboutUs;
